module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "OnHolidaysPopup"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h3', [_vm._v("On holidays")]), _c('span', [_vm._v(_vm._s(_vm.date1))])]), _c('div', {
    staticClass: "lines"
  }, _vm._l((_vm.kaleidersList), function(kaleider, index) {
    return _c('div', {
      staticClass: "line"
    }, [_c('img', {
      attrs: {
        "src": kaleider['picture']
      }
    }), _c('div', [_vm._v(_vm._s(kaleider['name']))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1971dbe"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./src/components/OnHolidaysPopup/OnHolidaysPopup.pug
// module id = 192
// module chunks = 1